<template>
  <div id="about">
    <b-row class="about-row">
      <b-col md="12">
        <h1>About Partnership 2020</h1>
        <p>
          The Partnership 2020: Leveraging US-India Cooperation in Higher Education to Harness
          Economic Opportunities and Innovation project goal is to strengthen the strategic
          partnership between the US and India through collaboration in higher education,
          research on key issue areas, related economic growth, and people-to-people linkages.
          This is a two-year project with most of the activities taking place in 2019 and 2020.
          <a :href="uno_is_url + '/project-team.php'" target="_blank" rel="noopener noreferrer">Our Project team</a>
          is experienced in US-India relations. Work products will include a <a href="/">searchable database</a>
          of US-India university partnerships,
          <a :href="uno_is_url + '/policy-recommendations.php'" target="_blank" rel="noopener noreferrer">policy recommendations</a>
          on enhancing US-India partnerships,
          <a :href="uno_is_url + '/practical-guide-to-partnerships.php'" target="_blank" rel="noopener noreferrer">practical guide to successful partnerships</a>,
          and <a :href="uno_is_url + '/request-for-proposals.php'" target="_blank" rel="noopener noreferrer">grants</a> to eligible US universities
          to enhance current or start new partnerships with Indian universities. Partnership 2020 is a collaborative agreement between
          University of Nebraska at Omaha (UNO) and US Department of State (DOS) with Center for Strategic and International Studies
          (CSIS) playing a key advisory role.
        </p>
      </b-col>
    </b-row>
    <br>
    <p>For more information about the US-India Partnership 2020 initiative, request for proposal instructions for grants to US universities, and access to other resources, please visit: </p>
    <a target="_blank" rel="noopener noreferrer" id="wrap" :href="uno_is_url + '/index.php'">{{ uno_is_url }}/index.php</a>
    <br>
    <b-row id="additionalInfo">
      <b-col>
        <h3>Additional Information</h3>
        <ul>
          <li><a target="_blank" rel="noopener noreferrer" :href="uno_is_url + '/index.php'">Project Home</a></li>
          <li><a target="_blank" rel="noopener noreferrer" :href="uno_is_url + '/request-for-proposals.php'">Request for Proposals</a></li>
          <li><a target="_blank" rel="noopener noreferrer" :href="uno_is_url + '/project-team.php'">Project Team</a></li>
          <li><a target="_blank" rel="noopener noreferrer" :href="uno_is_url + '/practical-guide-to-partnerships.php'">Practical Guide to Successful University Partnerships (Coming soon)</a></li>
          <li><a target="_blank" rel="noopener noreferrer" :href="uno_is_url + '/policy-recommendations.php'">Policy Recommendations (Coming soon)</a></li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'About',
  data: () => ({
    uno_is_url: 'https://www.unomaha.edu/international-studies-and-programs/engagement/partnership2020'
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$root.setTitle('About')
    })
  }
}
</script>

<style lang="scss" scoped>
  #about {
    padding-top: 2rem;
    margin-left: auto;
    margin-right: auto;
    width: 45rem;
  }

  h1 {
    padding-bottom: 1rem;
  }

  p {
    padding-bottom: 0rem;
  }

  #wrap {
    overflow-wrap: break-word;
  }

  #additionalInfo {
    margin-top: 1rem;
  }

  @media screen and (max-width: 767px) {
    #about {
      width: 80%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/About.vue